<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll>
          <v-toolbar-title class="font-weight-black primary--text"
            >Presupuesto
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="addItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
        </v-app-bar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda General"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-sheet class="overflow-y-auto" :max-height="windowHeigth + 100">
          <v-data-table
            dense
            :headers="headers"
            :items="presupuestos"
            :items-per-page="2"
            :search="search"
            sort-by="codigo"
            class="elevation-1"
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'items-per-page-options': [50, 100, 150, -1],
            }"
          >
            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn x-small text dark color="primary" @click="editItem(item)">
                <v-icon x-small>edit</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.gestion`]="{ item }">
              <div>
                {{ item.gestion === null ? "" : item.gestion }}
              </div>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'A'">
                <v-btn
                  color="success"
                  x-small
                  text
                  dark
                  @click="desactivar(item)"
                >
                  <v-icon x-small>check</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn color="error" x-small text dark @click="activar(item)">
                  <v-icon x-small>block</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.modificable`]="{ item }">
              <div v-if="item.modificable == true">
                <v-chip class="ma-2" color="success" x-small> SI </v-chip>
              </div>
              <div v-else>
                <v-chip class="ma-2" color="error" x-small> NO </v-chip>
              </div>
            </template>

            <template v-slot:[`item.version`]="{ item }">
              <div v-if="item.version == 'B'">
                <v-chip class="ma-2" color="blue" x-small dark>
                  Presupuesto Anual
                </v-chip>
              </div>
              <div v-else>
                <v-chip class="ma-2" color="black" x-small dark>
                  Proyección
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.aprobado`]="{ item }">
              <div v-if="item.aprobado == true">
                <v-chip class="ma-2" color="success" x-small> SI </v-chip>
              </div>
              <div v-else>
                <v-chip class="ma-2" color="error" x-small> NO </v-chip>
              </div>
            </template>

            <template v-slot:top>
              <v-dialog v-model="dialog" max-width="500px">
                <v-card ref="form">
                  <v-app-bar color="white" elevate-on-scroll>
                    <v-toolbar-title class="font-weight-black primary--text">{{
                      formTitle
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            large
                            @click="
                              rol == 'GER' ? mostrarAprobar() : mostrarMensaje()
                            "
                            :color="aprobado ? 'success' : 'default'"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon dark> check_circle </v-icon>
                          </v-btn>
                        </template>
                        <span>{{
                          aprobado
                            ? "Desaprobar Presupuesto"
                            : "Aprobar Presupuesto"
                        }}</span>
                      </v-tooltip>
                    </div>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            icon
                            large
                            color="primary"
                            @click="guardar()"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon dark> save </v-icon>
                          </v-btn>
                        </template>
                        <span>Guardar Registro(s)</span>
                      </v-tooltip>
                    </div>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            large
                            @click="close"
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon dark> close </v-icon>
                          </v-btn>
                        </template>
                        <span>Cerrar</span>
                      </v-tooltip>
                    </div>
                  </v-app-bar>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            outlined
                            dense
                            ref="codigo"
                            v-model="codigo"
                            @change="cambiaFechas"
                            :items="gestiones"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Gestión del presupuesto"
                            required
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            dense
                            ref="descripcion"
                            v-model="descripcion"
                            :rules="[rules.requerido, rules.max30, rules.min2]"
                            :error-messages="errorMessages"
                            label="Descripción"
                            placeholder="Descripción de Presupuesto"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            outlined
                            dense
                            ref="version"
                            v-model="version"
                            @change="cambiaFechas"
                            :items="versiones"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Tipo de Presupuesto"
                            required
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            type="text"
                            dense
                            ref="gestion"
                            v-model="gestion"
                            :rules="[rules.requerido]"
                            :error-messages="errorMessages"
                            label="Gestión"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogAprobar" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">¿Está seguro?</v-card-title>
                  <v-card-text>{{
                    aprobado
                      ? "Esta acción desaprobará el presupuesto seleccionado, y podrá modificarse"
                      : "Esta acción aprobará el presupuesto seleccionado, y ya no podrá modificarse"
                  }}</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogAprobar = false">Cancelar</v-btn>
                    <v-btn
                      color="primary"
                      text
                      @click="aprobado ? desaprobar() : aprobar()"
                      >Continuar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="listar">Reset</v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      presupuestos: [],

      dialog: false,
      dialogAprobar: false,
      windowWidth: window.innerWidth - 300,
      windowHeigth: window.innerHeight - 300,

      headers: [
        {
          text: "Opciones",
          value: "opciones",
          align: "center",
          class: "primary white--text text-subtitle-2",
          sortable: false,
          width: "10%",
        },
        {
          text: "Gestion",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          align: "center",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Tipo",
          value: "version",
          align: "center",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Modificable",
          value: "modificable",
          align: "center",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Aprobado",
          value: "aprobado",
          align: "center",
          filter: this.filtroCodigo,
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      editedIndex: -1,

      id: "",
      codigo: this.year,
      descripcion: "",
      year: new Date().getFullYear(),

      gestion: new Date().getFullYear(),

      version: "",
      modificable: "",
      aprobado: "",
      usuario_aprob: "",
      usuario_consolida: "",
      usuario: this.$store.state.usuario.user,
      rol: this.$store.state.usuario.rol,
      fecha_aprob: "",
      fecha_consolidado: "",
      consolidado: "",

      valida: 0,

      validaMensaje: [],

      versiones: [
        { id: "B", descripcion: "Presupuesto Anual" },
        { id: "P", descripcion: "Proyección" },
      ],
      gestiones: [],

      adCodigo: "",
      errorMessages: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Presupuesto " + this.gestion
        : "Actualizar Presupuesto " + this.gestion;
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        gestion: this.gestion,
        version: this.version,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
    },
  },

  created() {
    this.listar();
    this.generarGestiones();
  },

  methods: {
    formatoFecha(fecha) {
      if (fecha != "") {
        try {
          var m = new Date(fecha);
          var dateString =
            m.getUTCFullYear() +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            ("0" + m.getUTCDate()).slice(-2);
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    },
    //30/04/2071
    formatoFechaSpanish(fecha) {
      var anio = fecha.substring(6, 6);
      var mes = fecha.substring(3, 2);
      var dia = fecha.substring(0, 2);
      if (fecha != "") {
        try {
          var m = new Date(fecha);
          var dateString =
            ("0" + m.getUTCDate()).slice(-2) +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            m.getUTCFullYear();
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/presupuestos/listar")
        .then(function (response) {
          me.presupuestos = response.data;
          me.windowWidth = window.innerWidth - 300;
          me.windowHeigth = window.innerHeight - 300;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cambiaFechas() {
      this.descripcion = "Presupuesto " + this.codigo;
    },

    generarGestiones() {
      let me = this;
      var anioActual = new Date().getUTCFullYear();
      anioActual -= 3;

      for (var i = 0; i < 15; i++) {
        const dato = {
          id: anioActual.toString(),
          descripcion: anioActual.toString(),
        };
        this.gestiones.push(dato);
        anioActual += 1;
      }
    },

    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.gestion = item.gestion;

      this.version = item.version;
      this.modificable = item.modificable;
      this.aprobado = item.aprobado;
      this.usuario_aprob = item.usuario_aprob;
      this.usuario_consolida = item.usuario_consolida;

      this.fecha_aprob = item.fecha_aprob;
      this.fecha_consolidado = item.fecha_consolidado;
      this.consolidado = item.consolidado;

      this.editedIndex = 1;
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.gestion = "";

      this.version = "";
      this.modificable = "";
      this.aprobado = "";
      this.usuario_aprob = "";
      this.usuario_consolida = "";
      this.fecha_aprob = "";
      this.fecha_consolidado = "";
      this.consolidado = "";

      this.validaMensaje = [];
      this.editedIndex = -1;
    },

    addItem() {
      this.dialog = true;
    },

    mostrarAprobar() {
      this.dialogAprobar = true;
    },

    mostrarMensaje(item) {
      this.$store.dispatch("setSnackbar", {
        text: "Usted no tiene los privilegios suficientes para realizar esta Operación.",
        color: "error",
      });
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put("api/presupuestos/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            gestion: me.gestion,
            version: me.version,
            modificable: me.modificable,
            aprobado: me.aprobado,
            usuario_aprob: me.usuario_aprob,
            usuario_consolida: me.usuario_consolida,
            fecha_aprob: me.fecha_aprob,
            fecha_consolidado: me.fecha_consolidado,
            consolidado: me.consolidado,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: "Presupuesto modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/presupuestos/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            gestion: me.gestion,

            version: me.version,
            modificable: me.modificable,
            aprobado: me.aprobado,
            usuario_aprob: me.usuario_aprob,
            usuario_consolida: me.usuario_consolida,
            fecha_aprob: me.fecha_aprob,
            fecha_consolidado: me.fecha_consolidado,
            consolidado: me.consolidado,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: "Presupuesto creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/presupuestos/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Presupuesto activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/presupuestos/desactivar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Presupuesto desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    aprobar() {
      let me = this;
      axios
        .put("api/presupuestos/aprobar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.dialog = false;
          me.dialogAprobar = false;
          me.$store.dispatch("setSnackbar", {
            text: "Presupuesto aprobado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desaprobar() {
      let me = this;
      axios
        .put("api/presupuestos/desaprobar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.dialogAprobar = false;
          me.listar();
          me.dialog = false;
          me.$store.dispatch("setSnackbar", {
            text: "Presupuesto desaprobado exitosamente.",
            color: "warning",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
